export default {
  companySettingsMetadata: {
    fixateChangesButton: 'Fixate changes',
    fixateChangesCaption: 'Recent changes are not fixed',
    modulesButton: 'Learn more and connect',
    licenseStart: 'License start date',
    licenseEnd: 'License end date',
    maxEmployeeNumber: 'Allowed number of employees',
    banEmployees: 'You can block all employees from logging in.',
    hideSelfTesting: 'Turn off self-assessment',
    hideFeed: 'Turn off the feed',
    noModules: 'No modules available',
    titleExport: 'Export logging results',
    period: 'Select the logging period for which you want to get export data:',
    dateFrom: 'from',
    dateTo: 'to',
    confirmBanEmployees: {
      block: {
        title: 'Block?',
        text: 'All employees of the company will be blocked',
        button: 'Yes, block',
      },
      unblock: {
        title: 'Unblock?',
        text: 'All employees of the company will be unblocked',
        button: 'Yes, unblock',
      },
    },
    progress: {
      block: {
        title: 'Blocking employees',
      },
      unblock: {
        title: 'Unblocking employees',
      },
    },
    successMessages: {
      changeSettings: 'Settings changed successfully',
      blockEmployees: 'All employees of the company are blocked',
      unblockEmployees: 'All employees of the company are unblocked',
    },
    errorMessages: {
      changeSettings: 'Failed to change settings',
      hideSelfTesting: 'Failed to change self-assessment settings',
      hideFeed: 'Failed to change the feed settings',
      blockEmployees: 'Failed to block employees',
      unblockEmployees: 'Failed to unblock employees',
      getRecordTypes: 'Failed to get list of logging types',
      getBanEmployees: 'Failed to get employee ban status',
    },
  },
};
